export default __webpack_public_path__ + "static/media/hollydesk1.6.46532b36.mp4";